
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Lavorazione, StatoLavorazione, VariazioneLavorazione, Azione, ProgressoSpedizione as ProgressoDTO } from '@/models';
import { store, StoreActions } from '@/store';
import dayjs from 'dayjs';

@Component
export default class StampaDdt extends Vue {
    get testata() {
        let testata!: any;

        if(store.state.spedizioneCorrente) {
            testata = {
                dataDDT: store.state.spedizioneCorrente.dataDDT,
                numeroDDT: store.state.spedizioneCorrente.numeroDDT,
                numeroColli: store.state.spedizioneCorrente.numeroColli,
                note: store.state.spedizioneCorrente.note,
                causale: "C/LAVORAZIONE",
                porto: 'FRANCO',
                dataOraRitiro: dayjs(store.state.spedizioneCorrente.dataOraCreazione).format('MM/DD/YYYY HH:mm:ss')
            };
        }

        return testata;
    };
    
    get emittente() {
        let emittente!: any;

        if(store.state.spedizioneCorrente) {
            emittente = {
                Nome: store.state.spedizioneCorrente.ragioneSocialeMittente,
                IndirizzoLinea1: store.state.spedizioneCorrente.indirizzoMittenteRiga1,
                IndirizzoLinea2: store.state.spedizioneCorrente.indirizzoMittenteRiga2,
                Telefono: store.state.spedizioneCorrente.indirizzoMittenteRiga3,
                Fax: store.state.spedizioneCorrente.indirizzoMittenteRiga4,
                Email: store.state.spedizioneCorrente.idFornitore
            };
        }

        return emittente;
    };

    get spedizione() {
        let dest!: any;

        if(store.state.spedizioneCorrente) {
            dest = {
                Nome: store.state.spedizioneCorrente.ragioneSocialeDestinatario,
                IndirizzoLinea1: store.state.spedizioneCorrente.indirizzoDestinatarioRiga1,
                IndirizzoLinea2: store.state.spedizioneCorrente.indirizzoDestinatarioRiga2,
                Telefono: store.state.spedizioneCorrente.indirizzoDestinatarioRiga3,
                Fax: store.state.spedizioneCorrente.indirizzoDestinatarioRiga4,
            };
        }

        return dest;
    };
    
    get items() {
        var tabelle = { tabella: Array<any>() };
        if(store.state.spedizioneCorrente) {
            tabelle.tabella = new Array();
            var chunkSize=15;

            const righe = store.state.spedizioneCorrente.righe.map(r => {
                let riga = {
                    numeroCapi: r.qtaTaglia01+r.qtaTaglia02+r.qtaTaglia03+r.qtaTaglia04+r.qtaTaglia05+r.qtaTaglia06+r.qtaTaglia07+r.qtaTaglia08+r.qtaTaglia09+r.qtaTaglia10+r.qtaTaglia11+r.qtaTaglia12+r.qtaTaglia13+r.qtaTaglia14+r.qtaTaglia15+r.qtaTaglia16,
                    numeroDocumento: `${r.ordineNumero} / ${r.ordineLinea}`,
                    descrizione: `${r.codiceLAK}${r.firstCost=='S'?' USA':''}${r.campionario ? ' CAMPIONARIO' : ''} ${r.stagioneDecodificata.id} ${r.stagioneDecodificata.descrizione} ${r.lineaVenditaDecodificata?.id ?? ""} ${r.lineaVenditaDecodificata?.descrizione ?? ""} ${r.faseDecodificata.id} ${r.faseDecodificata.descrizione} ${r.lotto} ${r.codiceConsegna} ${r.modelloDecodificato.codiceParte} ${r.modelloDecodificato.descrizione} ${r.coloreDecodificato.codiceColore} ${r.coloreDecodificato.descrizione}`
                };
                return riga;
            });

            for (let i=0,j=righe.length; i<j; i+=chunkSize) {
                let item: any = { righe: righe.slice(i,i+chunkSize) };
                tabelle.tabella.push(item);
            }
        }

        return tabelle;
    }

    @Watch("$route.params.id", { immediate: true })
    onIdChanged(newId: string, oldId: string) {
        store.dispatch(StoreActions.GetSpedizione, newId);
    }
}

